import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
  query,
  orderBy,
  updateDoc,
} from "firebase/firestore";
import { db } from "../config/firebase";

const COLLECTION_NAME = "imagens_publicas_metadados";

/**
 * Serviço para gerenciar metadados de imagens públicas
 */
const imagensPublicasService = {
  /**
   * Criar metadados de uma imagem
   */
  async criarMetadados(dados) {
    try {
      const docRef = await addDoc(collection(db, COLLECTION_NAME), {
        ...dados,
        criadoEm: new Date().toISOString(),
      });
      return docRef.id;
    } catch (error) {
      console.error("Erro ao criar metadados:", error);
      throw error;
    }
  },

  /**
   * Listar todos os metadados de imagens
   */
  async listarMetadados() {
    try {
      const q = query(
        collection(db, COLLECTION_NAME),
        orderBy("criadoEm", "desc")
      );
      const querySnapshot = await getDocs(q);

      return querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
    } catch (error) {
      console.error("Erro ao listar metadados:", error);
      throw error;
    }
  },

  /**
   * Atualizar metadados de uma imagem
   */
  async atualizarMetadados(id, dados) {
    try {
      const docRef = doc(db, COLLECTION_NAME, id);
      await updateDoc(docRef, {
        ...dados,
        atualizadoEm: new Date().toISOString(),
      });
    } catch (error) {
      console.error("Erro ao atualizar metadados:", error);
      throw error;
    }
  },

  /**
   * Excluir metadados de uma imagem
   */
  async excluirMetadados(id) {
    try {
      await deleteDoc(doc(db, COLLECTION_NAME, id));
    } catch (error) {
      console.error("Erro ao excluir metadados:", error);
      throw error;
    }
  },

  /**
   * Buscar metadados por nome de arquivo
   */
  async buscarPorNomeArquivo(nomeArquivo) {
    try {
      const metadados = await this.listarMetadados();
      return metadados.find((m) => m.nomeArquivo === nomeArquivo);
    } catch (error) {
      console.error("Erro ao buscar por nome de arquivo:", error);
      throw error;
    }
  },
};

export default imagensPublicasService;
